import { render, staticRenderFns } from "./ShippingSideCard.vue?vue&type=template&id=515c9635&scoped=true&"
import script from "./ShippingSideCard.vue?vue&type=script&lang=js&"
export * from "./ShippingSideCard.vue?vue&type=script&lang=js&"
import style0 from "./ShippingSideCard.vue?vue&type=style&index=0&id=515c9635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c9635",
  null
  
)

export default component.exports